import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { useSelector } from "react-redux";
import { useState } from "react";
import PositiveOrNegetiveSTSkeleton from "../../../../../SearchTermSkeletons/PositiveOrNegetiveSTSkeleton";

const NegeativeST = ({ open, rowData, onClose }: any) => {
  const { positiveSTLoader, negetiveSearchTerm } = useSelector(
    (state: any) => state.aiRecomandationTab
  );

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const rows = negetiveSearchTerm?.map((item: any, index: number) => ({
    id: index + 1,
    searchTerm: item.search_term || "",
    matchType: item.search_term_match_type || "",
    lastSeen: item.last_seen || " ",
    negetive_level: item.negetive_level || "",
    imp: item.impression_last_30_days ?? 0,
    Clicks: item.clicks_last_30_days ?? 0,
    Cost: `${item.cost_last_30_days ?? 0}$`,
  }));

  const columns: GridColDef[] = [
    { field: "searchTerm", headerName: "Search Term", flex: 1, minWidth: 160 },
    { field: "matchType", headerName: "Match Type", flex: 0.6, minWidth: 110 },
    { field: "lastSeen", headerName: "Last Seen", flex: 0.6, minWidth: 110 },
    {
      field: "negetive_level",
      headerName: "Negetive Level",
      flex: 0.6,
      minWidth: 110,
    },
    { field: "imp", headerName: "IMP", flex: 0.6, minWidth: 110 },
    { field: "Clicks", headerName: "Clicks", flex: 0.6, minWidth: 110 },
    { field: "Cost", headerName: "Cost", flex: 0.6, minWidth: 110 },
  ];

  if (!rowData) return null;

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
    >
      <DialogTitle>{rowData?.keyword_name} - Negetive ST</DialogTitle>
      <DialogContent>
        {positiveSTLoader ? (
          <PositiveOrNegetiveSTSkeleton />
        ) : (
          <Box
            sx={{
              width: "100%",
              mt: 1,
              height: `${Math.min(rows.length * 52 + 56, 500)}px`,
            }}
          >
            <DataGridPro
              sx={{
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  { outline: "none" },
                "& .MuiDataGrid-cellEmpty": {
                  width: "auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                // Fixed column headers
                "& .MuiDataGrid-columnHeaders": {
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#fff",
                },
                // Row selection styling
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                  "&:hover": {
                    backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                  },
                },
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },
                "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#ffffff",
                  },
                "& .MuiDataGrid-cell.Mui-selected": {
                  backgroundColor: "inherit !important",
                },
                "& .MuiCheckbox-root": {
                  color: "#9c27b0 !important",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#9c27b0",
                },
                border: "none",
              }}
              density="compact"
              rows={positiveSTLoader ? [] : rows}
              columns={columns}
              // Pagination props
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50, 100]}
              // Other props
              disableColumnMenu
              disableColumnFilter
              disableColumnReorder
              sortingOrder={["asc", "desc"]}
              isCellEditable={() => false}
              disableRowSelectionOnClick
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NegeativeST;
